<m-title>Users</m-title>

<div class="mip-btn-container">
    <p-button
        label="Filters"
        icon="pi pi-filter-fill"
        (onClick)="toggleFilter()"
        styleClass="p-button-secondary mip-marbtn-r"></p-button>
    <p-button
        *ngIf="showAddButton()"
        label="Add"
        icon="pi pi-plus "
        (onClick)="DAcreateFunc()"
        styleClass="m-button-primary"></p-button>
</div>

<div [hidden]="!filterVisible" class="card card-pad-mod" rte="18G">
    <filter #filter [settings]="filterSettings" class="fix-dropdown-for-filter" rte="ft"></filter>
</div>

<div class="card main-container">
    <grid [tableSettings]="tableSettings" [gridSettings]="gridSettings" [filter]="filter" rte="1gv"></grid>
</div>

<p-dialog
    [(visible)]="displayInviteUserDialog"
    [modal]="true"
    [draggable]="false"
    [style]="{ 'max-width': '600px', width: '100%' }"
    header="Invite User"
    rte="fv">
    <form [formGroup]="inviteUserForm" autocomplete="off" class="inputs-group" [style.max-width]="'100%'" rte="fw">
        <div *ngIf="isGenericLogin || isClinicalSafetyOfficer" class="inputs-group-row">
            <label class="inputs-group-row-name asterisk-mark">Username:</label>
            <div class="inputs-group-row-value">
                <input [formControl]="userName" pInputText />
                <control-errors
                    [control]="userName"
                    [errors]="{
                        pattern: 'Only letters, digits or special characters <chars-allowed>-._@+</chars-allowed> are allowed'
                    }"></control-errors>
            </div>
        </div>
        <div class="inputs-group-row" rte="fx">
            <label class="inputs-group-row-name asterisk-mark" rte="fy">Email:</label>
            <div class="inputs-group-row-value" rte="fz">
                <input formControlName="email" pInputText rte="fA" />
                <control-errors [control]="inviteUserForm.get('email')"></control-errors>
            </div>
        </div>

        <div class="inputs-group-row" rte="fx">
            <label class="inputs-group-row-name asterisk-mark">Title:</label>
            <div class="inputs-group-row-value" rte="fz">
                <p-dropdown
                    [options]="titleOptions"
                    [showClear]="true"
                    placeholder="Select title"
                    formControlName="title"
                    class="custom-dropdown">
                </p-dropdown>
                <control-errors [control]="inviteUserForm.get('title')"></control-errors>
            </div>
        </div>

        <div class="inputs-group-row" rte="fB">
            <label class="inputs-group-row-name asterisk-mark" rte="fC">First name:</label>
            <div class="inputs-group-row-value" rte="fD">
                <input formControlName="firstName" pInputText rte="fE" />
                <control-errors [control]="inviteUserForm.get('firstName')"></control-errors>
            </div>
        </div>
        <div class="inputs-group-row" rte="fF">
            <label class="inputs-group-row-name asterisk-mark" rte="fG">Last name:</label>
            <div class="inputs-group-row-value" rte="fH">
                <input formControlName="lastName" pInputText rte="fI" />
                <control-errors [control]="inviteUserForm.get('lastName')"></control-errors>
            </div>
        </div>
        <div class="inputs-group-row" rte="fF">
            <label class="inputs-group-row-name asterisk-mark" rte="fG">Date Of Birth:</label>
            <div class="inputs-group-row-value">
                <p-calendar appendTo="body" [showIcon]="true" formControlName="dateOfBirth"></p-calendar>
                <control-errors [control]="inviteUserForm.get('dateOfBirth')"></control-errors>
            </div>
        </div>
        <div *role="[roles.MiProAdmin, roles.SuperAdmin]" class="inputs-group-row" rte="fJ">
            <div *ngIf="isGoverningBodyAdmin">
                <label class="inputs-group-row-name asterisk-mark" rte="fK"> Governing Body: </label>
                <div class="inputs-group-row-value" rte="fL">
                    <p-dropdown
                        formControlName="governingBody"
                        [options]="govBodyOptions"
                        [showClear]="true"
                        appendTo="body"
                        placeholder="Select Governing Body"
                        (onChange)="onGovBodyChanged()"
                        rte="fM">
                    </p-dropdown>
                </div>
            </div>
        </div>
        <div *role="[roles.MiProAdmin, roles.SuperAdmin]" class="inputs-group-row" rte="fJ">
            <div *ngIf="!isGoverningBodyAdmin">
                <label class="inputs-group-row-name asterisk-mark" rte="fK">
                    <naming-convention-label [singular]="true" [type]="'Org'"></naming-convention-label>:
                </label>
                <div class="inputs-group-row-value" rte="fL">
                    <p-dropdown
                        formControlName="organizationId"
                        [options]="companiesOptions"
                        [showClear]="true"
                        appendTo="body"
                        placeholder="Select {{ namingConvService.organisationSingular }}"
                        [panelStyle]="{'max-width': '400px', 'width': '100%'}"
                        (onChange)="onOrganizationChanged()"
                        rte="fM">
                    </p-dropdown>
                    <control-errors [control]="inviteUserForm.get('organizationId')"></control-errors>
                </div>
            </div>
        </div>
        <div *ngIf="!isGoverningBodyAdmin" class="inputs-group-row">
            <label class="inputs-group-row-name asterisk-mark">
                <naming-convention-label [type]="'Group'"></naming-convention-label>:
            </label>
            <div class="inputs-group-row-value">
                <organization-groups
                    formControlName="organizationGroups"
                    [organizationId]="inviteUserForm.get('organizationId').value"
                    [singleOrganization]="true">
                </organization-groups>
                <control-errors [control]="inviteUserForm.get('organizationGroups')"></control-errors>
            </div>
        </div>
        <div class="inputs-group-row" rte="fN">
            <label class="inputs-group-row-name asterisk-mark" rte="fO">User Types:</label>
            <div class="inputs-group-row-value" rte="fP">
                <p-multiSelect
                    formControlName="roles"
                    [options]="rolesOptions"
                    (onChange)="userTypeChanged()"
                    defaultLabel="Select roles"
                    dataKey="id"
                    appendTo="body"
                    [disabled]="!inviteUserForm.get('organizationId').value">
                </p-multiSelect>
                <control-errors
                    [control]="inviteUserForm.get('roles')"
                    [errors]="{
                        genericPatientRole: 'Generic Patient cannot be used with other User Types',
                        genericLoginRole: 'Generic Logins cannot be used with other User Types',
                        clinicalSafetyOfficerRole: 'Clinical Safety Officer cannot be used with other User Types',
                        formioExternalUser: 'FormIO External User cannot be used with other User Types'
                    }"></control-errors>
            </div>
        </div>

        <div *ngIf="!isGenericLogin && !isClinicalSafetyOfficer && inviteUserForm.get('roles').value?.length > 0" class="inputs-group-row">
            <div class="inputs-group-row-name"></div>
            <div class="inputs-group-row-value">
                <p-button
                    label="Reset Default Permissions"
                    icon="pi pi-arrow-down"
                    iconPos="right"
                    styleClass="p-button-sm"
                    (onClick)="setDefaultPermissions(true)"></p-button>
            </div>
        </div>

        <div *ngIf="!isGenericLogin && !isClinicalSafetyOfficer" class="inputs-group-row">
            <label class="inputs-group-row-name asterisk-mark">Permissions:</label>
            <div class="inputs-group-row-value">
                <p-multiSelect
                    #userPermissionsMultiselect
                    formControlName="permissions"
                    [options]="permissionOptions"
                    (onChange)="onUserPermissionChange($event)"
                    defaultLabel="Select permissions"
                    optionLabel="name"
                    dataKey="id"
                    appendTo="body"
                    [disabled]="!(inviteUserForm.get('organizationId').value && inviteUserForm.get('roles').value)">
                </p-multiSelect>
                <control-errors [control]="inviteUserForm.get('permissions')"> </control-errors>
            </div>
        </div>
    </form>

    <p-footer rte="fR">
        <form-buttons [disabled]="inviteUserForm.invalid || isInvalidGovBodyAdmin" [saving]="saving" [config]="formButtonsConfig">
        </form-buttons>
    </p-footer>
</p-dialog>

<m-historical-dialog [(visible)]="showHistorical" [items]="historicalItems"></m-historical-dialog>
